document.addEventListener('DOMContentLoaded', function () {
    var toggleButton  = document.getElementById('kennisbank-filter-btn');
    var filterPanel   = document.getElementById('kennisbank-filter-dropdown');
    var filterForm    = document.getElementById('kennisbank-filter-form');
    var buttonLabel   = document.getElementById('kennisbank-filter-label');
    var iconOpen      = document.getElementById('kennisbank-filter-icon-open');
    var iconClose     = document.getElementById('kennisbank-filter-icon-close');
    var applyButton   = document.getElementById('kennisbank-filter-apply');

    if (!toggleButton || !filterPanel) return;

    var isPanelOpen = false;
    var grid = document.getElementById('kennisbank-grid');

    function dimGrid() {
        if (grid) {
            grid.style.opacity = '0';
            grid.style.transform = 'translateY(30px)';
        }
    }

    // Enable CSS transition after the first frame so the closed initial state
    // (max-height: 0) doesn't animate on page load
    requestAnimationFrame(function () {
        filterPanel.classList.add('is-animating');
    });

    // ── Filter group border fix (hide border-r on last item in each row) ─────

    function updateFilterGroupBorders() {
        var groups = document.querySelectorAll('.kennis-filter-group');
        if (!groups.length) return;

        // Reset inline overrides
        groups.forEach(function (g) { g.style.borderLeftWidth = ''; });

        // divide-x only applies on md+
        if (window.innerWidth < 768) return;

        // Hide the divide-x border on items that start a new wrapped row
        var prevTop = -1;
        groups.forEach(function (el) {
            var top = Math.round(el.getBoundingClientRect().top);
            if (top !== prevTop) {
                el.style.borderLeftWidth = '0';
            }
            prevTop = top;
        });
    }

    window.addEventListener('resize', updateFilterGroupBorders);

    // ── Helpers ───────────────────────────────────────────────────────────────

    function buildFilterUrl() {
        var selectedIds = Array.from(filterForm.querySelectorAll('.kennisbank-cat-cb:checked'))
            .map(function (checkbox) { return checkbox.value; });
        var params = new URLSearchParams();
        if (selectedIds.length) params.set('cats', selectedIds.join(','));
        var sortInput = filterForm.querySelector('[name="sort"]');
        if (sortInput && sortInput.value) params.set('sort', sortInput.value);
        var queryString = params.toString();
        return filterForm.action + (queryString ? '?' + queryString : '');
    }

    function slideOpen() {
        filterPanel.style.maxHeight = filterPanel.scrollHeight + 'px';
        filterPanel.addEventListener('transitionend', function handler(e) {
            if (e.propertyName !== 'max-height') return;
            filterPanel.removeEventListener('transitionend', handler);
            // Add is-open so overflow: visible kicks in (content won't be clipped)
            filterPanel.classList.add('is-open');
        }, { once: true });
    }

    function slideClose(onComplete) {
        filterPanel.classList.remove('is-open');
        // Re-measure in case content shifted while open, then animate to 0
        filterPanel.style.maxHeight = filterPanel.scrollHeight + 'px';
        filterPanel.offsetHeight; // force reflow so browser registers the start value
        filterPanel.style.maxHeight = '0';
        if (onComplete) {
            filterPanel.addEventListener('transitionend', function handler(e) {
                if (e.propertyName !== 'max-height') return;
                filterPanel.removeEventListener('transitionend', handler);
                onComplete();
            }, { once: true });
        }
    }

    function updateButtonAppearance(panelIsOpen) {
        toggleButton.setAttribute('aria-expanded', String(panelIsOpen));
        toggleButton.classList.toggle('bg-secondary', !panelIsOpen);
        toggleButton.classList.toggle('text-primary',  !panelIsOpen);
        toggleButton.classList.toggle('bg-primary',    panelIsOpen);
        toggleButton.classList.toggle('text-surface',  panelIsOpen);
        buttonLabel.textContent = panelIsOpen ? 'Filter sluiten' : 'Filter instellen';
        iconOpen.classList.toggle('hidden',  panelIsOpen);
        iconClose.classList.toggle('hidden', !panelIsOpen);
    }

    // ── Open / close ──────────────────────────────────────────────────────────

    function openPanel() {
        if (isPanelOpen) return;
        isPanelOpen = true;
        slideOpen();
        updateButtonAppearance(true);
        // Run after panel is visible so getBoundingClientRect() returns real positions
        requestAnimationFrame(updateFilterGroupBorders);
    }

    function closePanel(applyFilters) {
        if (!isPanelOpen) return;
        isPanelOpen = false;
        updateButtonAppearance(false);

        if (applyFilters && filterForm) {
            // Let the slide animation finish before navigating so it feels intentional
            slideClose(function () {
                window.location.href = buildFilterUrl();
            });
        } else {
            slideClose();
        }
    }

    // ── Event listeners ───────────────────────────────────────────────────────

    toggleButton.addEventListener('click', function (e) {
        e.stopPropagation();
        if (isPanelOpen) {
            closePanel(false);
        } else {
            openPanel();
        }
    });

    if (applyButton) {
        applyButton.addEventListener('click', function (e) {
            e.stopPropagation();
            var url = buildFilterUrl();

            var spinner = document.getElementById('kennisbank-spinner');
            if (spinner) spinner.classList.remove('hidden');

            dimGrid();
            closePanel(false);
            window.location.href = url;
        });
    }

    // Dim grid when navigating via sort toggle, pill removal, or pagination
    document.querySelectorAll('.sort-toggle, .active-filters a, nav[aria-label="Paginering"] a').forEach(function (link) {
        link.addEventListener('click', dimGrid);
    });

    // Clicking outside the panel closes it without applying changes
    document.addEventListener('click', function (e) {
        if (isPanelOpen && !filterPanel.contains(e.target) && e.target !== toggleButton) {
            closePanel(false);
        }
    });

    // Escape closes the panel without applying changes
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && isPanelOpen) {
            closePanel(false);
            toggleButton.focus();
        }
    });

    // ── "Alle [taxonomy]" button sync ─────────────────────────────────────────

    // Toggle .is-active on the "Alle" button; CSS handles the visual via .is-active
    function syncAlleButton(groupId) {
        var allBtn = filterForm.querySelector('.kennisbank-alle-btn[data-group="' + groupId + '"]');
        if (!allBtn) return;

        var anyChecked = filterForm.querySelectorAll(
            '.kennisbank-cat-cb[data-group="' + groupId + '"]:checked'
        ).length > 0;

        // "Alle" is active when nothing in the group is selected
        allBtn.classList.toggle('is-active', !anyChecked);
    }

    // ── Checkbox & "Alle" button interactions ─────────────────────────────────

    if (filterForm) {
        filterForm.querySelectorAll('.kennisbank-cat-cb').forEach(function (checkbox) {
            checkbox.addEventListener('change', function () {
                if (checkbox.dataset.group) {
                    syncAlleButton(checkbox.dataset.group);
                }
            });
        });

        filterForm.querySelectorAll('.kennisbank-alle-btn').forEach(function (allBtn) {
            allBtn.addEventListener('click', function () {
                var groupId = allBtn.dataset.group;

                // Uncheck every checkbox in this group; CSS resets their visuals via :checked
                filterForm.querySelectorAll('.kennisbank-cat-cb[data-group="' + groupId + '"]').forEach(function (checkbox) {
                    checkbox.checked = false;
                });

                syncAlleButton(groupId);
            });
        });
    }
});
